<template>
  <div>
    <mdb-modal
      scrollable
      removeBackdrop
      size="md"
      :show="modalShow"
      @close="handleClose"
      info
    >
      <mdb-modal-header>
        <mdb-modal-title>{{ $t("benefit_modal_title") }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        {{ $t("benefit_modal_description") }}
        <mdb-input
          v-model="benefitLocal.title"
          :label="$t('benefit_modal_benefit_title')"
          type="textarea"
          rows="3"
        />
        <mdb-input
          @change="validateBenefit"
          v-model="benefitLocal.text"
          :label="$t('benefit_modal_benefit_description')"
          type="textarea"
          rows="3"
        />
        <!--mdb-input
          v-model="benefitLocal.order"
          :label="$t('benefit_modal_order')"
          type="number"
        /-->
        <mdb-select
          v-if="benefitTypeVisible"
          v-model="benefitTypes"
          @getValue="getTypeValue"
          color="primary"
          :placeholder="$t('benefit_modal_coupontype')"
          label=""
        />
        <mdb-input
          v-model="benefitLocal.buttontext"
          :label="$t('benefit_modal_button_text')"
          type="text"
        />
        <mdb-input
          @change="validateBenefit"
          v-model="fromdate"
          :label="$t('benefit_modal_from')"
          type="date"
        />
        <mdb-input
          @change="validateBenefit"
          v-model="todate"
          :label="$t('benefit_modal_to')"
          type="date"
        />
        <mdb-input
          v-model="benefitLocal.url"
          :label="$t('benefit_modal_url')"
          type="text"
        />
        <mdb-input
          v-model="benefitLocal.restrictions"
          :label="$t('benefit_modal_restrictions')"
          type="textarea"
        />
        <mdb-input
          v-model="benefitLocal.codegeneric"
          :label="$t('benefit_modal_benefitcodegeneric')"
          type="text"
        />
        <mdb-input
          v-model="benefitLocal.barcode"
          :label="$t('benefit_modal_benefitbarcode')"
          type="text"
        />
        <mdb-input
          v-model="benefitLocal.qrcode"
          :label="$t('benefit_modal_benefitqrcode')"
          type="text"
        />
        <mdb-input
          v-model="code"
          type="checkbox"
          id="checkBoxBenefitCode"
          :label="$t('benefit_modal_benefitcode')"
        />
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn
          @click="handleOk"
          color="primary"
          size="sm"
          :disabled="benefitValidation"
          >{{ $t("benefit_modal_save") }}</mdb-btn
        >
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbInput,
  mdbSelect,
} from "mdbvue";
export default {
  name: "BenefitModal",
  props: {
    benefit: Object,
    editing: {
      type: Boolean,
      default: false,
    },
    modalShow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbInput,
    mdbSelect,
  },
  data() {
    return {
      benefitTypeVisible: false,
      benefitLocal: Object.assign({}, this.benefit),
      benefitTypes: [
        { text: "ONCE", value: "ONCE" },
        { text: "ALWAYS", value: "ALWAYS" },
        { text: "WEB", value: "WEB" },
        { text: "TABLERESERVATION", value: "TABLERESERVATION" },
      ],
    };
  },
  mounted() {
    this.getBenefitTypes();
  },
  methods: {
    validateBenefit() {
      if (
        this.benefitLocal.validfrom.length > 4 &&
        this.benefitLocal.validto.length > 4
      ) {
        return false;
      } else {
        return true;
      }
    },
    handleOk() {
      this.benefitLocal.order = parseInt(this.benefitLocal.order);
      this.$emit("modal-ok", this.benefitLocal, this.editing);
    },
    handleClose() {
      this.$emit("modal-cancelled");
    },
    getTypeValue(val, text) {
      this.benefitLocal.type = val;
      console.log(text);
    },
    getBenefitTypes() {
      this.benefitTypes.forEach((element) => {
        if (element.value === this.benefitLocal.type) element.selected = true;
      });
      this.benefitTypeVisible = true;
    },
    getCode() {
      return this.benefitLocal.code === 1 ? true : false;
    },
  },
  computed: {
    benefitValidation: {
      // getter
      get: function () {
        return this.validateBenefit();
      },
    },
    code: {
      // getter
      get: function () {
        return this.getCode();
      },
      // setter
      set: function (newValue) {
        this.benefitLocal.code = newValue ? 1 : 0;
      },
    },
    fromdate: {
      // getter
      get: function () {
        return this.benefitLocal.validfrom.split(" ")[0];
      },
      // setter
      set: function (newValue) {
        this.benefitLocal.validfrom = newValue;
      },
    },
    todate: {
      // getter
      get: function () {
        return this.benefitLocal.validto.split(" ")[0];
      },
      // setter
      set: function (newValue) {
        this.benefitLocal.validto = newValue;
      },
    },
  },
};
</script>

<style>
.md-form > input[type="date"]:not(.browser-default) + label {
  transform-origin: 0px 24px !important;
  transform: matrix(0.8, 0, 0, 0.8, 0, -14);
}
</style>
